import { render, staticRenderFns } from "./BaseFieldGroupItem.vue?vue&type=template&id=6f8e181e"
import script from "./BaseFieldGroupItem.vue?vue&type=script&lang=js"
export * from "./BaseFieldGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports